import { Box, Button, Dialog, DialogContent, DialogTitle, Divider, Grid, Stack, TextField, Typography, } from "@mui/material";
import PaperDraggable from "../../PaperDraggable";
import { formatarCPFCNPJ, formatarMonetárioParaNúmero, formatarValorMonetario, permitirApenasNumeros } from "../../../helpers/masks";
import BasicDatePicker from "../../BasicDatePicker";
import SelectBancos from "../../SelectsSimpleApiQuery/SelectBancos";
import { TBancos } from "../../../types/api/financeiro/bancos";
import moment, { Moment } from "moment";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { DadoValorPrinter } from "../DisplayDados/DadoValorPrinter";
import { desformatarCPFCNPJ } from "../../../helpers/unmask";
import SelectCentroCusto from "../../SelectsSimpleApiQuery/SelectCentroCusto";
import { IDataCentroCustos } from "../../../types/api/contabilidade/pesquisar-centro-custos";

export default function DialogCheque({
    open,
    valor,
    defaultValues,
    isEdit,
    onSubmit,
    onClose
}: DialogChequeProps) {

    const methods = useForm<TPagamentoCheque>({
        defaultValues: {
            valor: defaultValues?.valor ? formatarValorMonetario(defaultValues?.valor) : formatarValorMonetario(valor),
            cheque_banco: defaultValues?.cheque_banco || null,
            cheque_agencia: defaultValues?.cheque_agencia || '',
            cheque_agencia_digito: defaultValues?.cheque_agencia_digito || '',
            cheque_conta: defaultValues?.cheque_conta || '',
            cheque_conta_digito: defaultValues?.cheque_conta_digito || '',
            cheque_documento: defaultValues?.cheque_documento || '',
            cheque_nome_emissor: defaultValues?.cheque_nome_emissor || '',
            cheque_praca: defaultValues?.cheque_praca || '',
            cheque_seq: defaultValues?.cheque_seq || '',
            parcelas: defaultValues?.parcelas ? defaultValues?.parcelas.map(parcela => ({
                valor: parcela.valor,
                cheque_num: parcela.cheque_num ?? '',
                data_vencimento: moment(parcela.data_vencimento, 'DD/MM/YYYY')
            })) : [],
            departamento_centro_custo: defaultValues?.departamento_centro_custo || null
        }
    })
    const { handleSubmit, control, getValues } = methods;

    const parcelas = getValues().parcelas

    //Functions
    const handleClickSubmit = (data: TPagamentoCheque) => {
        const params: TPagamentoChequeParams = {
            valor: formatarMonetárioParaNúmero(data.valor),
            cheque_banco: data.cheque_banco,
            cheque_agencia: data.cheque_agencia,
            cheque_agencia_digito: data.cheque_agencia_digito,
            cheque_conta: data.cheque_conta,
            cheque_conta_digito: data.cheque_conta_digito,
            cheque_documento: desformatarCPFCNPJ(data.cheque_documento),
            cheque_nome_emissor: data.cheque_nome_emissor,
            cheque_praca: data.cheque_praca,
            cheque_seq: data.cheque_seq,
            parcelas: data.parcelas.map(parcela => ({
                valor: parcela.valor,
                cheque_num: parcela.cheque_num ?? '',
                data_vencimento: moment(parcela.data_vencimento, 'YYYY-MM-DD').format("DD/MM/YYYY")
            })),
            departamento_centro_custo: data.departamento_centro_custo
        }
        onSubmit(params);
    }

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                onClose={onClose}
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
                fullWidth
                maxWidth={"sm"}
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Cheque</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} mt={1}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Controller
                                name="cheque_banco"
                                control={control}
                                rules={{ required: 'Campo obrigatório' }}
                                render={({ field, fieldState: { error, invalid } }) => (
                                    <SelectBancos
                                        required
                                        value={field.value}
                                        error={invalid}
                                        errorMessage={error?.message}
                                        onChange={(value) => field.onChange(value)}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Stack direction="row" alignItems="center" gap={1}>
                                <Controller
                                    name="cheque_agencia"
                                    control={control}
                                    rules={{ required: 'Campo obrigatório' }}
                                    render={({ field, fieldState: { error, invalid } }) => (
                                        <TextField
                                            required
                                            label='Agência'
                                            type="text"
                                            value={field.value}
                                            onChange={(e) => field.onChange(permitirApenasNumeros(e.target.value))}
                                            error={invalid}
                                            helperText={error ? "Campo obrigatório" : ""}
                                        />
                                    )}
                                />
                                -
                                <Controller
                                    name="cheque_agencia_digito"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            label='Digito'
                                            type="text"
                                            value={field.value}
                                            onChange={(e) => field.onChange((e.target.value))}
                                        />
                                    )}
                                />
                            </Stack>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Stack direction="row" alignItems="center" gap={1}>
                                <Controller
                                    name="cheque_conta"
                                    control={control}
                                    rules={{ required: 'Campo obrigatório' }}
                                    render={({ field, fieldState: { error, invalid } }) => (
                                        <TextField
                                            label='Conta'
                                            required
                                            type="text"
                                            value={field.value}
                                            onChange={(e) => field.onChange(permitirApenasNumeros(e.target.value))}
                                            error={invalid}
                                            helperText={error ? "Campo obrigatório" : ""}
                                        />
                                    )}
                                />
                                -
                                <Controller
                                    name="cheque_conta_digito"
                                    control={control}
                                    rules={{ required: 'Campo obrigatório' }}
                                    render={({ field, fieldState: { error, invalid } }) => (
                                        <TextField
                                            required
                                            label='Digito'
                                            type="text"
                                            value={field.value}
                                            onChange={(e) => field.onChange((e.target.value))}
                                            error={invalid}
                                            helperText={error ? "Campo obrigatório" : ""}
                                        />
                                    )}
                                />
                            </Stack>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Controller
                                name="cheque_nome_emissor"
                                control={control}
                                rules={{ required: 'Campo obrigatório' }}
                                render={({ field, fieldState: { error, invalid } }) => (
                                    <TextField
                                        required
                                        fullWidth
                                        label='Nome do emissor'
                                        type="text"
                                        value={field.value}
                                        onChange={(e) => field.onChange(e.target.value)}
                                        error={invalid}
                                        helperText={error ? "Campo obrigatório" : ""}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Controller
                                name="cheque_documento"
                                control={control}
                                rules={{ required: 'Campo obrigatório' }}
                                render={({ field, fieldState: { error, invalid } }) => (
                                    <TextField
                                        required
                                        fullWidth
                                        label='CPF/CNPJ do emissor'
                                        type="text"
                                        value={field.value}
                                        error={invalid}
                                        onChange={(e) => field.onChange(formatarCPFCNPJ(e.target.value))}
                                        helperText={error ? "Campo obrigatório" : ""}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Controller
                                name="cheque_seq"
                                control={control}
                                rules={{ required: 'Campo obrigatório' }}
                                render={({ field, fieldState: { error, invalid } }) => (
                                    <TextField
                                        required
                                        fullWidth
                                        label='Sequência cheque'
                                        type="text"
                                        value={field.value}
                                        error={invalid}
                                        onChange={(e) => field.onChange(permitirApenasNumeros(e.target.value))}
                                        helperText={error ? "Campo obrigatório" : ""}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 6 }}>
                            <Controller
                                name="cheque_praca"
                                control={control}
                                rules={{ required: 'Campo obrigatório' }}
                                render={({ field, fieldState: { error, invalid } }) => (
                                    <TextField
                                        required
                                        fullWidth
                                        label='Praça'
                                        type="text"
                                        value={field.value}
                                        error={invalid}
                                        onChange={(e) => field.onChange(e.target.value)}
                                        helperText={error ? "Campo obrigatório" : ""}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid size={{ xs: 6 }}>
                            <Controller
                                name="departamento_centro_custo"
                                control={control}
                                rules={{ required: 'Campo obrigatório' }}
                                render={({ field, fieldState: { error, invalid } }) => (
                                    <SelectCentroCusto
                                        value={field.value}
                                        required
                                        error={invalid}
                                        onChange={(valor) => field.onChange(valor)}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid  size={{ xs: 12 }}><Divider /></Grid>

                        {
                            parcelas.length > 0 &&
                            parcelas.map((parcela, index) => {
                                return (
                                    <Grid size={{ xs: 12}} container key={index}>
                                        <Grid size={{ xs: 6}}>
                                            <Box display={'flex'} alignItems={'center'} justifyContent={'center'} gap={2}>
                                                <Typography fontWeight={'bold'} variant="h6">{index + 1}°)</Typography>
                                                <Controller
                                                    name={`parcelas.${index}.cheque_num`}
                                                    rules={{ required: 'Campo obrigatório' }}
                                                    control={control}
                                                    render={({ field, fieldState: { error, invalid } }) => (
                                                        <TextField
                                                            label={`Número cheque`}
                                                            required
                                                            value={field.value}
                                                            fullWidth
                                                            onChange={(e) => {
                                                                field.onChange(permitirApenasNumeros(e.target.value))
                                                            }}
                                                            error={invalid}
                                                            helperText={error ? "Campo obrigatório" : ""}
                                                        />
                                                    )}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid size={{ xs: 6}}>
                                            <Controller
                                                name={`parcelas.${index}.data_vencimento`}
                                                rules={{ required: 'Campo obrigatório' }}
                                                control={control}
                                                render={({ field, fieldState: { error, invalid } }) => (
                                                    <BasicDatePicker
                                                        label="Vencimento *"
                                                        blockPastDates
                                                        disabled
                                                        value={field.value ? moment(field.value) : null}
                                                        onChange={(data) => field.onChange(data)}
                                                        formatString="DD/MM/YYYY"
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </DialogContent>

                <Stack direction="row" justifyContent={'space-between'} px={3} py={2}  >
                    <Box>
                        <Controller
                            name="valor"
                            control={control}
                            rules={{ required: 'Campo obrigatório' }}
                            render={({ field, fieldState: { error, invalid } }) => (
                                <DadoValorPrinter titulo="Valor cheque" valor={`${field.value}`} />
                            )}
                        />

                    </Box>
                    <Stack direction="row" spacing={2}>
                        <Button onClick={onClose} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={handleSubmit(handleClickSubmit)} color="primary" variant="contained" >
                            {isEdit ? "Editar" : "Receber"}
                        </Button>
                    </Stack>
                </Stack>
            </Dialog>
        </FormProvider>
    )
}

interface DialogChequeProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (data: TPagamentoChequeParams) => void;
    valor: number;
    defaultValues?: TPagamentoChequeParams;
    isEdit: boolean;
}

export type TPagamentoCheque = {
    valor: string,
    cheque_banco: TBancos | null,
    cheque_agencia: string,
    cheque_agencia_digito: string,
    cheque_conta: string,
    cheque_conta_digito: string,
    cheque_documento: string,
    cheque_nome_emissor: string,
    cheque_praca: string,
    cheque_seq: string,
    parcelas: TParcelasCheque[]
    departamento_centro_custo: IDataCentroCustos | null
}

export type TPagamentoChequeParams = {
    departamento_centro_custo: IDataCentroCustos | null,
    valor: number,
    cheque_banco: TBancos | null,
    cheque_agencia: string,
    cheque_agencia_digito: string,
    cheque_conta: string,
    cheque_conta_digito: string,
    cheque_documento: string,
    cheque_nome_emissor: string,
    cheque_praca: string,
    cheque_seq: string,
    parcelas: TParcelasChequeParams[]
}

type TParcelasCheque = {
    valor: number,
    data_vencimento: Moment | null,
    cheque_num: string | null,
}

type TParcelasChequeParams = {
    valor: number,
    data_vencimento: string,
    cheque_num: string,
}